<template>
    <input
        :id="id"
        :dusk="id"
        :class="mergedClasses"
        :type="type"
        :value="value"
        :min="min"
        :max="max"
        :placeholder="placeholder"
        :step="step"
        :tabindex="tabindex"
        :autocomplete="autocomplete"
        :readonly="readonly"
        v-bind="id ? { id } : ''"
        spellcheck="false"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('onEnter', $event)"
        @change="$emit('change', $event)"
        @keyup="$emit('keyup', $event)"
        @keydown="restrict"
    />
</template>

<script>
export default {
    name: "VInput",
    props: {
        type: {
            type: String,
            default: "text",
            validator: val =>
                ["number", "text", "email", "password", "file", "tel"].includes(val)
        },
        id: {type: String, default: null},
        placeholder: {type: String},
        classes: {type: String, default: "form__input"},
        min: {type: String, default: "0"},
        max: {type: String, default: null},
        step: {type: String, default: "1"},
        autocomplete: {type: String},
        tabindex: {type: String},
        error: {type: String},
        readonly: {type: Boolean, default: false},
        value: {}
    },
    computed: {
        mergedClasses() {
            return `${this.classes} ${
                this.error && !this.type.includes("file") ? "is-invalid" : ""
            }`;
        }
    },
    methods: {
        restrict(event) {
            if (this.type !== "number") return;

            const value = this.value
                ? (this.value[0] === '.'
                    ? parseInt(`0${this.value}${event.key}`)
                    : parseInt(`${this.value}${event.key}`))
                : parseInt(event.key);
            const minValid = value >= parseInt(this.min);
            const maxValid =
                !this.max || (this.max && value <= parseInt(this.max));

            const e = event || window.event;
            const key = e.keyCode || e.which;

            const notAllowedKey = [188, 189, 109, 69, 107].includes(key);

            if (notAllowedKey || !minValid || !maxValid) {
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            }
        }
    }
};
</script>
